import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActionsCard = ({ onRebook, onManageItinerary, onSubmitReview, onViewProfile }) => {
  const quickActions = [
    {
      id: 'rebook',
      label: 'Rebook Trip',
      description: 'Book similar trips again',
      icon: 'RotateCcw',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      onClick: onRebook
    },
    {
      id: 'itinerary',
      label: 'Manage Itinerary',
      description: 'View and edit your plans',
      icon: 'Calendar',
      color: 'text-secondary',
      bgColor: 'bg-secondary/10',
      onClick: onManageItinerary
    },
    {
      id: 'review',
      label: 'Submit Review',
      description: 'Share your experience',
      icon: 'Star',
      color: 'text-accent',
      bgColor: 'bg-accent/10',
      onClick: onSubmitReview
    },
    {
      id: 'profile',
      label: 'Update Profile',
      description: 'Manage preferences',
      icon: 'User',
      color: 'text-success',
      bgColor: 'bg-success/10',
      onClick: onViewProfile
    }
  ];

  return (
    <div className="bg-card rounded-xl border border-border p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-heading font-semibold text-foreground">
          Quick Actions
        </h3>
        <Icon name="Zap" size={20} className="text-muted-foreground" />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {quickActions.map((action) => (
          <button
            key={action.id}
            onClick={action.onClick}
            className="flex items-center space-x-4 p-4 rounded-lg border border-border hover:shadow-soft transition-all duration-200 hover:border-primary/20 group"
          >
            <div className={`w-12 h-12 ${action.bgColor} rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform`}>
              <Icon name={action.icon} size={24} className={action.color} />
            </div>
            <div className="flex-1 text-left">
              <p className="font-medium text-foreground mb-1">
                {action.label}
              </p>
              <p className="text-sm text-muted-foreground">
                {action.description}
              </p>
            </div>
            <Icon name="ChevronRight" size={16} className="text-muted-foreground group-hover:text-primary transition-colors" />
          </button>
        ))}
      </div>

      <div className="mt-6 pt-6 border-t border-border">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-foreground mb-1">
              Need Help?
            </p>
            <p className="text-xs text-muted-foreground">
              Contact our 24/7 support team
            </p>
          </div>
          <Button
            variant="outline"
            size="sm"
            iconName="MessageCircle"
            iconPosition="left"
            onClick={() => window.location.href = '/real-time-customer-support'}
          >
            Get Support
          </Button>
        </div>
      </div>
    </div>
  );
};

export default QuickActionsCard;